import { useState, useRef, useEffect } from "react";
import api from "../api";

const ICONE_TIPO = {
  "application/pdf": "📄", "image/": "🖼️", "video/": "🎥",
  "audio/": "🎵", "application/vnd.ms-excel": "📊",
  "application/vnd.openxmlformats-officedocument.spreadsheetml": "📊",
  "application/msword": "📝",
  "application/vnd.openxmlformats-officedocument.wordprocessingml": "📝",
  "text/": "📃", "application/zip": "🗜️",
};
function getIcone(tipo="") {
  for (const [k,v] of Object.entries(ICONE_TIPO)) { if (tipo.startsWith(k)) return v; }
  return "📎";
}
function fmtBytes(b) {
  if (!b) return "";
  if (b<1024) return b+" B";
  if (b<1024*1024) return (b/1024).toFixed(1)+" KB";
  return (b/1024/1024).toFixed(1)+" MB";
}
function fmtData(d) {
  if (!d) return "";
  return new Date(d).toLocaleDateString("pt-BR",{day:"2-digit",month:"short",year:"numeric"});
}
function fmt(v) { return v ? "R$"+Number(v).toLocaleString("pt-BR",{minimumFractionDigits:0,maximumFractionDigits:2}) : "R$0"; }

const ETAPAS_LABEL = { prospeccao:"Prospecção", contato:"Contato", reuniao:"Reunião", proposta:"Proposta enviada", aprovacao:"Aguard. aprovação", fechado:"Fechado", perdido:"Perdido" };
const ETAPAS_COR   = { prospeccao:"#579bfc", contato:"#fdab3d", reuniao:"#66ccff", proposta:"#a25ddc", aprovacao:"#e2445c", fechado:"#00c875", perdido:"#98A2B3" };

function TextoComMencoes({ texto }) {
  if (!texto) return null;
  return <span>{texto.split(/(@\w+(?:\s\w+)?)/g).map((p,i)=>
    p.startsWith("@") ? <span key={i} style={{ background:"#FDE7DA", color:"#EE6A1A", borderRadius:4, padding:"1px 5px", fontWeight:600, fontSize:12 }}>{p}</span> : p
  )}</span>;
}

function InputMencao({ value, onChange, usuarios, placeholder }) {
  const [showM, setShowM]   = useState(false);
  const [filtro, setFiltro] = useState("");
  const [pos, setPos]       = useState(0);
  const ref = useRef();

  const handleChange = (e) => {
    const val = e.target.value, cursor = e.target.selectionStart;
    onChange(val); setPos(cursor);
    const match = val.slice(0,cursor).match(/@(\w*)$/);
    if (match) { setFiltro(match[1].toLowerCase()); setShowM(true); }
    else setShowM(false);
  };

  const selecionar = (nome) => {
    const antes = value.slice(0,pos).replace(/@(\w*)$/, `@${nome.split(" ")[0]} `);
    onChange(antes + value.slice(pos));
    setShowM(false); ref.current?.focus();
  };

  const filtrados = usuarios.filter(u=>u.nome.toLowerCase().includes(filtro)).slice(0,5);

  return (
    <div style={{ position:"relative", flex:1 }}>
      <textarea ref={ref} value={value} onChange={handleChange} placeholder={placeholder} rows={2}
        onKeyDown={e=>{ if(e.key==="Escape") setShowM(false); }}
        style={{ width:"100%", boxSizing:"border-box", background:"#F5F6F7", border:"1.5px solid #E3E6E9", borderRadius:10, padding:"10px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif", resize:"vertical" }}
        onFocus={e=>e.target.style.borderColor="#EE6A1A"}
        onBlur={e=>{ e.target.style.borderColor="#E3E6E9"; setTimeout(()=>setShowM(false),200); }}/>
      {showM && filtrados.length>0 && (
        <div style={{ position:"absolute", bottom:"calc(100% + 4px)", left:0, zIndex:500, background:"var(--card-bg)", border:"1px solid #E3E6E9", borderRadius:10, padding:6, minWidth:200, boxShadow:"0 8px 24px rgba(0,0,0,.12)" }}>
          <div style={{ fontSize:11, color:"#9499A5", fontWeight:600, padding:"4px 8px 6px", letterSpacing:".04em", textTransform:"uppercase" }}>Mencionar</div>
          {filtrados.map(u=>{
            const cores=["#EE6A1A","#e2445c","#00c875","#fdab3d","#a25ddc"];
            const cor=cores[(u.nome?.charCodeAt(0)||0)%cores.length];
            return (
              <div key={u._id} onMouseDown={()=>selecionar(u.nome)}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"7px 10px", borderRadius:7, cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background="#F5F6F7"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div style={{ width:28, height:28, borderRadius:8, background:cor+"22", border:`1.5px solid ${cor}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, color:cor, flexShrink:0 }}>
                  {u.nome?.split(" ").slice(0,2).map(n=>n[0]).join("").toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)" }}>{u.nome}</div>
                  <div style={{ fontSize:11, color:"#9499A5" }}>{u.role}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function ModalDetalheNegociacao({ lead, onClose, onAtualizar }) {
  const [aba, setAba]               = useState("comentarios");
  const [comentario, setComentario] = useState("");
  const [loadComent, setLoadComent] = useState(false);
  const [editando, setEditando]     = useState(null); // { id, texto }
  const [loadAnexo, setLoadAnexo]   = useState(false);
  const [dragOver, setDragOver]     = useState(false);
  const [usuarios, setUsuarios]     = useState([]);
  const [clientes, setClientes]     = useState([]);

  // Aba Cliente
  const [buscaCliente, setBuscaCliente] = useState(lead?.nomeCliente||"");
  const [clienteVinculado, setClienteVinculado] = useState(lead?.clienteId||null);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [loadCliente, setLoadCliente] = useState(false);

  // Aba Serviços
  const [servicos, setServicos]     = useState(lead?.servicos||[]);
  const [novoServ, setNovoServ]     = useState({ nome:"", valor:"", descricao:"" });
  const [loadServ, setLoadServ]     = useState(false);

  const fileRef = useRef();

  useEffect(()=>{
    api.get("/users").then(r=>setUsuarios(r.data)).catch(()=>{});
    api.get("/clientes?limit=200").then(r=>setClientes(r.data.clientes||[])).catch(()=>{});
    // Carregar cliente vinculado
    if (lead?.clienteId) {
      api.get(`/clientes/${lead.clienteId}`).then(r=>setClienteSelecionado(r.data)).catch(()=>{});
    }
    setServicos(lead?.servicos||[]);
  },[lead?._id]);

  if (!lead) return null;
  const etapaCor   = ETAPAS_COR[lead.stage]  || "#579bfc";
  const etapaLabel = ETAPAS_LABEL[lead.stage] || lead.stage;
  const atividades = lead.atividades || [];
  const anexos     = lead.anexos     || [];

  // Filtrar clientes pela busca
  const clientesFiltrados = buscaCliente.length>1
    ? clientes.filter(c=>c.nomeEmpresa?.toLowerCase().includes(buscaCliente.toLowerCase())||c.nomeContato?.toLowerCase().includes(buscaCliente.toLowerCase())).slice(0,6)
    : [];

  const vincularCliente = async (cliente) => {
    setLoadCliente(true);
    try {
      await api.put(`/leads/${lead._id}`, { clienteId:cliente._id, nomeCliente:cliente.nomeEmpresa });
      setClienteSelecionado(cliente);
      setClienteVinculado(cliente._id);
      setBuscaCliente(cliente.nomeEmpresa);
      onAtualizar();
    } finally { setLoadCliente(false); }
  };

  const desvincularCliente = async () => {
    await api.put(`/leads/${lead._id}`, { clienteId:null, nomeCliente:"" });
    setClienteSelecionado(null); setClienteVinculado(null); setBuscaCliente("");
    onAtualizar();
  };

  const adicionarServico = async () => {
    if (!novoServ.nome.trim()) return;
    setLoadServ(true);
    try {
      const novos = [...servicos, { ...novoServ, valor:Number(novoServ.valor)||0, createdAt:new Date() }];
      await api.put(`/leads/${lead._id}`, { servicos:novos });
      setServicos(novos);
      setNovoServ({ nome:"", valor:"", descricao:"" });
      onAtualizar();
    } finally { setLoadServ(false); }
  };

  const removerServico = async (idx) => {
    const novos = servicos.filter((_,i)=>i!==idx);
    await api.put(`/leads/${lead._id}`, { servicos:novos });
    setServicos(novos);
    onAtualizar();
  };

  const salvarEdicao = async () => {
    if (!editando?.texto.trim()) return;
    try {
      await api.put(`/leads/${lead._id}/atividades/${editando.id}`, { descricao: editando.texto });
      setEditando(null);
      onAtualizar();
    } catch(e) { alert("Erro: " + e.message); }
  };

  const enviarComentario = async () => {
    if (!comentario.trim()) return;
    setLoadComent(true);
    try {
      await api.post(`/leads/${lead._id}/atividades`, { tipo:"nota", descricao:comentario });
      setComentario(""); onAtualizar();
    } finally { setLoadComent(false); }
  };

  const enviarAnexo = async (file) => {
    if (!file) return;
    setLoadAnexo(true);
    try {
      const fd = new FormData();
      fd.append("arquivo", file);
      await api.post(`/anexos/${lead._id}`, fd, { headers:{ "Content-Type":"multipart/form-data" } });
      onAtualizar();
    } catch(e) { alert("Erro: "+(e.response?.data?.erro||e.message)); }
    finally { setLoadAnexo(false); }
  };

  const excluirAnexo = async (idx) => {
    if (!window.confirm("Remover este anexo?")) return;
    await api.delete(`/anexos/${lead._id}/${idx}`);
    onAtualizar();
  };

  const inp = { width:"100%", boxSizing:"border-box", background:"#F5F6F7", border:"1.5px solid #E3E6E9", borderRadius:8, padding:"9px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif" };

  const totalServicos = servicos.reduce((a,s)=>a+Number(s.valor||0),0);

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.45)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:"var(--card-bg)", borderRadius:16, width:"100%", maxWidth:660, maxHeight:"90vh", display:"flex", flexDirection:"column", boxShadow:"0 24px 64px rgba(0,0,0,.2)", overflow:"hidden" }} onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding:"20px 24px 0", borderBottom:"1px solid #E3E6E9" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, flexWrap:"wrap" }}>
                <div style={{ background:etapaCor, borderRadius:4, padding:"2px 10px", fontSize:11, fontWeight:700, color:"#fff" }}>{etapaLabel}</div>
                {lead.grupoNegociacaoLabel&&<div style={{ background:"#F5F6F7", borderRadius:4, padding:"2px 10px", fontSize:11, color:"#6B7280" }}>{lead.grupoNegociacaoLabel}</div>}
              </div>
              <h2 style={{ margin:0, fontSize:18, fontWeight:700, color:"#1A1D23", letterSpacing:"-.02em" }}>{lead.nome}</h2>
              {lead.empresa&&<div style={{ fontSize:13, color:"#6B7280", marginTop:3 }}>{lead.empresa}</div>}
            </div>
            <button onClick={onClose} style={{ background:"#F5F6F7", border:"none", borderRadius:8, width:32, height:32, fontSize:18, color:"#6B7280", cursor:"pointer", flexShrink:0, marginLeft:12 }}>×</button>
          </div>

          {/* Info rápida */}
          <div style={{ display:"flex", gap:20, paddingBottom:12, flexWrap:"wrap" }}>
            {lead.valor>0&&<div><div style={{ fontSize:10, color:"#9499A5", fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Valor</div><div style={{ fontSize:15, fontWeight:700, color:"#EE6A1A" }}>{fmt(lead.valor)}</div></div>}
            {lead.nomeResponsavel&&<div><div style={{ fontSize:10, color:"#9499A5", fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Responsável</div><div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)" }}>{lead.nomeResponsavel}</div></div>}
            {lead.dataFechamento&&<div><div style={{ fontSize:10, color:"#9499A5", fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Fechamento</div><div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)" }}>{fmtData(lead.dataFechamento)}</div></div>}
            {totalServicos>0&&<div><div style={{ fontSize:10, color:"#9499A5", fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>Total serviços</div><div style={{ fontSize:15, fontWeight:700, color:"#00c875" }}>{fmt(totalServicos)}</div></div>}
          </div>

          {/* Abas */}
          <div style={{ display:"flex", overflowX:"auto" }}>
            {[["anexos",`📎 Anexos (${anexos.length})`],["cliente","🏢 Cliente"],["servicos",`🔧 Serviços (${servicos.length})`],["comentarios",`💬 Comentários (${atividades.length})`]].map(([id,label])=>(
              <button key={id} onClick={()=>setAba(id)}
                style={{ padding:"10px 14px", fontSize:13, fontWeight:aba===id?600:400, cursor:"pointer", border:"none", background:"transparent", color:aba===id?"#EE6A1A":"#6B7280", borderBottom:aba===id?"2px solid #EE6A1A":"2px solid transparent", marginBottom:-1, whiteSpace:"nowrap" }}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Conteúdo */}
        <div style={{ flex:1, overflowY:"auto", padding:24 }}>

          {/* COMENTÁRIOS */}
          {aba==="comentarios"&&(
            <div>
              <div style={{ fontSize:11, color:"#9499A5", marginBottom:8 }}>
                <span style={{ background:"#F5F6F7", borderRadius:4, padding:"1px 6px", fontWeight:600, color:"#6B7280" }}>@</span> Digite @ para mencionar · Ctrl+Enter para enviar
              </div>
              <div style={{ display:"flex", gap:8, marginBottom:20 }}>
                <InputMencao value={comentario} onChange={setComentario} usuarios={usuarios} placeholder="Escrever comentário..."/>
                <button onClick={enviarComentario} disabled={loadComent||!comentario.trim()}
                  style={{ background:"#EE6A1A", border:"none", borderRadius:10, padding:"0 16px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", opacity:!comentario.trim()?.5:1, alignSelf:"stretch", minWidth:70 }}>
                  {loadComent?"...":"Enviar"}
                </button>
              </div>
              {atividades.length===0&&<div style={{ textAlign:"center", padding:"40px 0", color:"#98A2B3" }}><div style={{ fontSize:32, marginBottom:8 }}>💬</div><div style={{ fontSize:13 }}>Nenhum comentário ainda</div></div>}
              {[...atividades].reverse().map((a,i)=>{
                const cores=["#EE6A1A","#e2445c","#00c875","#fdab3d","#a25ddc"];
                const cor=cores[(a.nomeUsuario?.charCodeAt(0)||0)%cores.length];
                return (
                  <div key={i} style={{ display:"flex", gap:12, marginBottom:16 }}>
                    <div style={{ width:34, height:34, borderRadius:9, background:cor+"22", border:`2px solid ${cor}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:cor, flexShrink:0 }}>
                      {a.nomeUsuario?.split(" ").slice(0,2).map(n=>n[0]).join("").toUpperCase()||"?"}
                    </div>
                    <div style={{ flex:1, background:"#F5F6F7", borderRadius:10, padding:"10px 14px" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:5 }}>
                        <span style={{ fontSize:12, fontWeight:600, color:cor }}>{a.nomeUsuario}</span>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <span style={{ fontSize:11, color:"#98A2B3" }}>{new Date(a.createdAt).toLocaleDateString("pt-BR")} {new Date(a.createdAt).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}</span>
                          <button onClick={()=>setEditando({id:a._id,texto:a.descricao})} style={{ background:"none", border:"none", color:"#98A2B3", cursor:"pointer", fontSize:11, padding:"1px 5px", borderRadius:4 }}
                            onMouseEnter={e=>{ e.currentTarget.style.color="#EE6A1A"; e.currentTarget.style.background="#FDE7DA"; }}
                            onMouseLeave={e=>{ e.currentTarget.style.color="#98A2B3"; e.currentTarget.style.background="none"; }}>
                            ✏️ Editar
                          </button>
                        </div>
                      </div>
                      {editando?.id===a._id ? (
                        <div style={{ display:"flex", gap:6, marginTop:4 }}>
                          <textarea value={editando.texto} onChange={e=>setEditando(prev=>({...prev,texto:e.target.value}))} rows={2}
                            style={{ flex:1, background:"var(--card-bg)", border:"1.5px solid #EE6A1A", borderRadius:8, padding:"8px 10px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif", resize:"vertical" }}/>
                          <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                            <button onClick={salvarEdicao} style={{ background:"#EE6A1A", border:"none", borderRadius:7, padding:"5px 10px", color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer" }}>✓</button>
                            <button onClick={()=>setEditando(null)} style={{ background:"#F5F6F7", border:"none", borderRadius:7, padding:"5px 10px", color:"#6B7280", fontSize:12, cursor:"pointer" }}>✕</button>
                          </div>
                        </div>
                      ) : (
                        <div style={{ fontSize:13, color:"var(--text-primary)", lineHeight:1.6 }}><TextoComMencoes texto={a.descricao}/></div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ANEXOS */}
          {aba==="anexos"&&(
            <div>
              <div onDragOver={e=>{ e.preventDefault(); setDragOver(true); }} onDragLeave={()=>setDragOver(false)}
                onDrop={e=>{ e.preventDefault(); setDragOver(false); const f=e.dataTransfer.files[0]; if(f) enviarAnexo(f); }}
                onClick={()=>fileRef.current?.click()}
                style={{ border:`2px dashed ${dragOver?"#EE6A1A":"#d0d2d9"}`, borderRadius:12, padding:"28px 20px", textAlign:"center", cursor:"pointer", background:dragOver?"#FDE7DA":"#F5F6F7", marginBottom:20 }}>
                <input ref={fileRef} type="file" style={{ display:"none" }} onChange={e=>{ const f=e.target.files[0]; if(f) enviarAnexo(f); e.target.value=""; }}/>
                <div style={{ fontSize:28, marginBottom:8 }}>{loadAnexo?"⏳":"📎"}</div>
                <div style={{ fontSize:13, fontWeight:600, color:dragOver?"#EE6A1A":"#6B7280" }}>{loadAnexo?"Enviando...":"Clique ou arraste arquivos"}</div>
                <div style={{ fontSize:11, color:"#98A2B3", marginTop:4 }}>Qualquer tipo · Máximo 20MB</div>
              </div>
              {anexos.length===0&&<div style={{ textAlign:"center", padding:"20px 0", color:"#98A2B3" }}><div style={{ fontSize:32, marginBottom:6 }}>📁</div><div style={{ fontSize:13 }}>Nenhum anexo ainda</div></div>}
              {anexos.map((a,i)=>(
                <div key={i} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", background:"#F5F6F7", borderRadius:10, marginBottom:8, border:"1px solid #E3E6E9" }}>
                  <span style={{ fontSize:24, flexShrink:0 }}>{getIcone(a.tipo)}</span>
                  <div style={{ flex:1, overflow:"hidden" }}>
                    <div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{a.nome}</div>
                    <div style={{ fontSize:11, color:"#9499A5" }}>{fmtBytes(a.tamanho)} · {a.nomeUsuario} · {fmtData(a.createdAt)}</div>
                  </div>
                  <div style={{ display:"flex", gap:6 }}>
                    <a href={a.url} target="_blank" rel="noreferrer" style={{ background:"#EE6A1A", borderRadius:7, padding:"5px 12px", color:"#fff", fontSize:12, fontWeight:600, textDecoration:"none" }}>↓ Baixar</a>
                    <button onClick={()=>excluirAnexo(i)} style={{ background:"#feecec", border:"none", borderRadius:7, padding:"5px 10px", color:"#e2445c", fontSize:12, fontWeight:600, cursor:"pointer" }}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* CLIENTE */}
          {aba==="cliente"&&(
            <div>
              {clienteSelecionado ? (
                <div>
                  <div style={{ background:"#F5F6F7", borderRadius:12, padding:20, marginBottom:16, border:"1px solid #E3E6E9" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                        <div style={{ width:44, height:44, borderRadius:10, background:"#EE6A1A22", border:"1.5px solid #EE6A1A44", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, fontWeight:700, color:"#EE6A1A" }}>
                          {clienteSelecionado.nomeEmpresa?.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div style={{ fontSize:16, fontWeight:700, color:"#1A1D23" }}>{clienteSelecionado.nomeEmpresa}</div>
                          {clienteSelecionado.nomeContato&&<div style={{ fontSize:13, color:"#6B7280" }}>{clienteSelecionado.nomeContato}</div>}
                        </div>
                      </div>
                      <button onClick={desvincularCliente} style={{ background:"#feecec", border:"none", borderRadius:7, padding:"5px 12px", color:"#e2445c", fontSize:12, fontWeight:600, cursor:"pointer" }}>Desvincular</button>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      {[["📞",clienteSelecionado.telefone],["📧",clienteSelecionado.email],["🏭",clienteSelecionado.segmento],["📍",`${clienteSelecionado.cidade||""}${clienteSelecionado.estado?"/"+clienteSelecionado.estado:""}`]].filter(([,v])=>v).map(([icon,val],i)=>(
                        <div key={i} style={{ fontSize:13, color:"var(--text-primary)" }}><span style={{ marginRight:6 }}>{icon}</span>{val}</div>
                      ))}
                    </div>
                    {clienteSelecionado.valorMensal>0&&(
                      <div style={{ marginTop:12, background:"#FDE7DA", borderRadius:8, padding:"8px 12px", display:"flex", justifyContent:"space-between" }}>
                        <span style={{ fontSize:12, color:"#6B7280" }}>MRR do cliente</span>
                        <span style={{ fontSize:14, fontWeight:700, color:"#EE6A1A" }}>{fmt(clienteSelecionado.valorMensal)}/mês</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ marginBottom:16 }}>
                    <label style={{ fontSize:11, fontWeight:600, color:"#6B7280", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Vincular cliente existente</label>
                    <div style={{ position:"relative" }}>
                      <input value={buscaCliente} onChange={e=>setBuscaCliente(e.target.value)} placeholder="Buscar cliente pelo nome..."
                        style={{ ...inp, paddingLeft:32 }}
                        onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="#E3E6E9"}/>
                      <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", color:"#9499A5", fontSize:13 }}>🔍</span>
                    </div>
                    {clientesFiltrados.length>0&&(
                      <div style={{ background:"var(--card-bg)", border:"1px solid #E3E6E9", borderRadius:10, marginTop:4, boxShadow:"0 8px 24px rgba(0,0,0,.1)", overflow:"hidden" }}>
                        {clientesFiltrados.map(c=>(
                          <div key={c._id} onClick={()=>vincularCliente(c)}
                            style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", cursor:"pointer", borderBottom:"1px solid #ECEEF0" }}
                            onMouseEnter={e=>e.currentTarget.style.background="#F5F6F7"}
                            onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                            <div style={{ width:32, height:32, borderRadius:8, background:"#EE6A1A22", display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:700, color:"#EE6A1A" }}>
                              {c.nomeEmpresa?.charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)" }}>{c.nomeEmpresa}</div>
                              {c.nomeContato&&<div style={{ fontSize:11, color:"#9499A5" }}>{c.nomeContato}</div>}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ borderTop:"1px solid #E3E6E9", paddingTop:16 }}>
                    <label style={{ fontSize:11, fontWeight:600, color:"#6B7280", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Ou salvar nome manualmente</label>
                    <div style={{ display:"flex", gap:8 }}>
                      <input value={buscaCliente} onChange={e=>setBuscaCliente(e.target.value)} placeholder="Nome do cliente..."
                        style={{ ...inp, flex:1 }}
                        onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="#E3E6E9"}/>
                      <button onClick={async()=>{ if(!buscaCliente.trim()) return; await api.put(`/leads/${lead._id}`,{nomeCliente:buscaCliente}); onAtualizar(); }}
                        style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 16px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer" }}>
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* SERVIÇOS */}
          {aba==="servicos"&&(
            <div>
              {/* Adicionar serviço */}
              <div style={{ background:"#F5F6F7", borderRadius:12, padding:16, marginBottom:20 }}>
                <div style={{ fontSize:12, fontWeight:700, color:"#6B7280", marginBottom:12, letterSpacing:".04em", textTransform:"uppercase" }}>+ Adicionar serviço</div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 130px", gap:10, marginBottom:10 }}>
                  <div>
                    <label style={{ fontSize:11, color:"#9499A5", fontWeight:600, display:"block", marginBottom:4 }}>Nome do serviço *</label>
                    <input value={novoServ.nome} onChange={e=>setNovoServ(s=>({...s,nome:e.target.value}))} placeholder="Ex: Instalação CFTV"
                      style={inp} onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="#E3E6E9"}/>
                  </div>
                  <div>
                    <label style={{ fontSize:11, color:"#9499A5", fontWeight:600, display:"block", marginBottom:4 }}>Valor (R$)</label>
                    <input type="number" value={novoServ.valor} onChange={e=>setNovoServ(s=>({...s,valor:e.target.value}))} placeholder="0"
                      style={inp} onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="#E3E6E9"}/>
                  </div>
                </div>
                <div style={{ marginBottom:10 }}>
                  <label style={{ fontSize:11, color:"#9499A5", fontWeight:600, display:"block", marginBottom:4 }}>Descrição</label>
                  <input value={novoServ.descricao} onChange={e=>setNovoServ(s=>({...s,descricao:e.target.value}))} placeholder="Detalhes do serviço..."
                    style={inp} onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="#E3E6E9"}/>
                </div>
                <button onClick={adicionarServico} disabled={loadServ||!novoServ.nome.trim()}
                  style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 20px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", opacity:!novoServ.nome.trim()?.5:1 }}>
                  {loadServ?"Salvando...":"+ Adicionar"}
                </button>
              </div>

              {/* Lista de serviços */}
              {servicos.length===0&&(
                <div style={{ textAlign:"center", padding:"30px 0", color:"#98A2B3" }}>
                  <div style={{ fontSize:32, marginBottom:8 }}>🔧</div>
                  <div style={{ fontSize:13 }}>Nenhum serviço adicionado</div>
                </div>
              )}
              {servicos.map((s,i)=>(
                <div key={i} style={{ background:"var(--card-bg)", border:"1px solid #E3E6E9", borderRadius:10, padding:"12px 16px", marginBottom:10, display:"flex", gap:12, alignItems:"flex-start" }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                      <div style={{ fontSize:14, fontWeight:600, color:"#1A1D23" }}>{s.nome}</div>
                      <div style={{ fontSize:15, fontWeight:700, color:"#EE6A1A" }}>{fmt(s.valor)}</div>
                    </div>
                    {s.descricao&&<div style={{ fontSize:12, color:"#6B7280", lineHeight:1.5 }}>{s.descricao}</div>}
                  </div>
                  <button onClick={()=>removerServico(i)} style={{ background:"#feecec", border:"none", borderRadius:7, padding:"5px 10px", color:"#e2445c", fontSize:12, fontWeight:600, cursor:"pointer", flexShrink:0 }}>✕</button>
                </div>
              ))}

              {servicos.length>0&&(
                <div style={{ background:"#FDE7DA", borderRadius:10, padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontSize:13, fontWeight:600, color:"#6B7280" }}>Total dos serviços</span>
                  <span style={{ fontSize:18, fontWeight:800, color:"#EE6A1A" }}>{fmt(totalServicos)}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
